enum API {
  ACCOUNTS = '/api/v1/fxtrade/allowed-accounts',
  AUTH = '/auth/info',
  SIGNIN = '/auth/signin',
  CONVERSION = '/api/v1/fxtrade/calculate-conversion',
  REQUEST_QUOTE = '/api/v1/fxtrade/request-quote',
  EXECUTE_TRADE = '/api/v1/fxtrade/execute-trade',
  IBB_REDIRECT = '/redirect/ibb'
}

export default API;
